import { registerMessages } from "../../i18n/runtime";
import { reportsEn } from "./messages.en";
import { reportsEs, reportsNamesEs } from "./messages.es";

registerMessages("en", reportsEn);
registerMessages("es", reportsEs);
registerMessages("es", reportsNamesEs);
